import React, { useState } from "react";
import "bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";

import { Flex, Text } from "@chakra-ui/react";
import { ChakraFAIcon } from "@/components/ui/Icon";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const DatePickerFilter = ({
	additionalClasses,
	startDate = moment().startOf("day"),
	maxDate,
	endDate = moment().endOf("day"),
	opens = "center",
	onCallback,
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
}) => {
	const dateFormat = "MMM DD, YYYY";
	const dateTimeFormat = "MMM DD, YYYY (hh:mm A)";

	const ranges = {
		Today: [moment().startOf("day"), moment().endOf("day"), "today"],
		Yesterday: [moment().subtract(1, "days").startOf("day"), moment().subtract(1, "days").endOf("day"), "yesterday"],
		"Last 7 Days": [moment().subtract(6, "days").startOf("day"), moment().endOf("day"), "7days"],
		"Last 30 Days": [moment().subtract(29, "days").startOf("day"), moment().endOf("day"), "30days"],
		"This Month": [moment().startOf("month").startOf("day"), moment().endOf("month"), "month"],
		"Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month"), "lastmonth"],
	};

	const [datePickerButtonActive, setDatePickerButtonActive] = useState(false);

	const getDateString = () => {
		if (ranges.Today[0].isSame(startDate) && ranges.Today[1].isSame(endDate)) {
			return `Today, ${startDate.format(dateFormat)}`;
		} else if (ranges.Yesterday[0].isSame(startDate) && ranges.Yesterday[1].isSame(endDate)) {
			return `Yesterday, ${startDate.format(dateFormat)}`;
		} else if (startDate.isSame(endDate)) {
			return `${startDate.format(dateFormat)}`;
		} else {
			return `${startDate.format(dateFormat)} to ${endDate.format(dateFormat)}`;
		}
	};

	const children = (
		<span className={`${additionalClasses ? additionalClasses : ""} ${datePickerButtonActive ? "active" : ""}`.trim()}>
			<Flex px={2} py={2.5} alignItems="center" w={"100%"} gap={3} cursor="pointer" borderRadius="md">
				<ChakraFAIcon icon="fa-calendar" size="sm" color="neutrals.400" />
				<Text flex={1}>{getDateString()}</Text>
				<ChakraFAIcon icon="fa-angle-down" size="sm" color="neutrals.400" />
			</Flex>
		</span>
	);

	const locale = {
		format: dateTimeFormat,
		cancelLabel: "Reset",
	};

	const handleShow = () => {
		setDatePickerButtonActive(true);
	};

	const handleHide = () => {
		setDatePickerButtonActive(false);
	};

	return (
		<DateRangePicker
			initialSettings={{
				startDate,
				endDate,
				maxDate,
				ranges,
				opens,
				locale,
				timePicker: true,
			}}
			children={children}
			onCallback={onCallback}
			onShow={handleShow}
			onHide={handleHide}
		/>
	);
};
